import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => api.loadRecommendations())
        }
    }, [])

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            {/* <div class="ns-font-4">No results found for '{query}'</div> */}
            <div class="nosto-rec-container">
                {/* <div class="nosto_element" id="noresults-nosto-1"></div> */}
                <div class="nosto_element" id="noresult-searchpage-nosto-1"></div>
            </div>
        </div>
    )
}